"use client";

import React from "react";
import type { PopoverPositionContext } from "./types";

export default React.createContext<PopoverPositionContext | null>(null);
